<div class="delete-container" *ngIf="pages">

  <div class="card">
    <h2 class="title">{{ "MENU.DASHBOARD.titlee" | translate }}</h2>
    <p class="desc">{{ "MENU.DASHBOARD.messagee" | translate }}</p>

    <!-- Toggle Button (Always Clickable Except During Loading) -->
    <button 
      class="delete-btn"
      [disabled]="isLoading"
      (click)="openConfirmModal()">

      <span *ngIf="!isLoading">
        <!-- Dynamic button label -->
        {{ pages.value === 'true' 
            ? ("MENU.DASHBOARD.disabled" | translate) 
            : ("MENU.DASHBOARD.button" | translate) 
        }}
      </span>

      <div class="loader" *ngIf="isLoading"></div>
    </button>

    <!-- Status Message -->
    <p class="status-text" [ngClass]="pages.value === 'true' ? 'red' : 'green'">
      {{ pages.value === 'true' 
          ? ("MENU.DASHBOARD.flag_true" | translate)
          : ("MENU.DASHBOARD.flag_false" | translate)
      }}
    </p>
  </div>

  <!-- Confirmation Modal -->
  <div class="modal-backdrop" *ngIf="showConfirm">
    <div class="modal-card">

      <h3>{{ "MENU.DASHBOARD.confirm_title" | translate }}</h3>
      <p>{{ "MENU.DASHBOARD.confirm_message" | translate }}</p>

      <div class="modal-actions">

        <button class="cancel-btn" (click)="closeConfirmModal()">
          {{ "MENU.DASHBOARD.cancel" | translate }}
        </button>

        <button class="confirm-btn" (click)="submitToggle()">
          {{ "MENU.DASHBOARD.confirm" | translate }}
        </button>

      </div>

    </div>
  </div>

</div>
